export default __webpack_public_path__ + "static/media/AnElementOfBlank.16327ca7.jpg";